
import React from 'react';
import CityMetauxPage from '@/components/valorisation/CityMetauxPage';

const AchatMetauxToulouse = () => {
  return (
    <CityMetauxPage
      cityName="Toulouse"
      departmentName="Haute-Garonne"
      departmentCode="31"
      region="Occitanie"
      description="Capitale de l'Occitanie et métropole aéronautique européenne, Toulouse bénéficie de notre expertise dans le rachat de métaux issus de l'industrie aéronautique, spatiale et de haute technologie."
      specialities={[
        "Métaux aéronautiques et spatiaux",
        "Alliages haute technologie",
        "Équipements industriels de pointe",
        "Métaux de construction urbaine"
      ]}
      nearbyAreas={[
        "Colomiers", "Tournefeuille", "Muret", "Blagnac", "Balma", "L'Union"
      ]}
      heroImage="https://images.unsplash.com/photo-1539650116574-75c0c6d73d0e?w=1280&q=80"
    />
  );
};

export default AchatMetauxToulouse;
